import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'lyceo-content',
  imports: [],
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentComponent {
  public readonly background: InputSignal<boolean> = input<boolean>(false);
  public readonly alternate: InputSignal<boolean> = input<boolean>(false);
  public readonly maxWidth: InputSignal<boolean> = input<boolean>(true);
}
